import { differenceInYears } from "date-fns";

/**
 * Mirrors the API's `isAdult` (`apps/api/src/utils/dates/is-adult.ts`), including its deliberate
 * asymmetry: an UNKNOWN birthdate counts as an adult.
 *
 * We would rather offer a passenger we did not need to than hide one we cannot reach — and no
 * flow may treat somebody as a minor, and so as unable to sign, on the strength of a missing date.
 */
export function isAdult(birthdate: Date | string | null | undefined): boolean {
  if (!birthdate) {
    return true;
  }

  return differenceInYears(new Date(), new Date(birthdate)) >= 18;
}
